import { ReactNode } from 'react';
import cn from 'classnames';

import Text from '@/components/common/Text/Text';
import { useGentleBlurField } from '@/components/form/lib/useGentleBlurField';

import './InputField.style.scss';

type InputFieldProps = {
  name: string;
  label?: ReactNode;
  className?: string;
  placeholder?: string;
  type?: string;
  /** Optional HTML autocomplete token (e.g. "given-name"). */
  autoComplete?: string;
  'data-testid'?: string;
};

function InputField(props: InputFieldProps) {
  const {
    name,
    label,
    className,
    placeholder,
    type = 'text',
    autoComplete,
    'data-testid': dataTestId
  } = props;
  const [field, meta /*, helpers */] = useGentleBlurField({ name });

  return (
    <div className={cn(className, 'InputField')}>
      <label className='InputField-label'>{label}</label>
      <input
        className={cn('InputField-input', {
          Error: meta.touched && meta.error
        })}
        placeholder={placeholder}
        {...field}
        type={type}
        autoComplete={autoComplete}
        data-testid={dataTestId}
      />
      {meta.touched && meta.error && (
        <div className='InputField-error'>
          <Text className='InputField-error-text'>{meta.error}</Text>
        </div>
      )}
    </div>
  );
}

export default InputField;
